import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BreadcrumbStep } from './breadcrumb.model';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'jhi-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  @Input()
  steps: Array<BreadcrumbStep> = [];

  activeStepIndex: number;

  private subscription: Subscription;

  constructor(private router: Router) {

  }

  ngOnInit() {
    this.activeStepIndex = this.steps.findIndex(step => step.isActive);
    this.subscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.steps.forEach((step, stepIndex) => {
            step.isActive = step.route === event.urlAfterRedirects;
            this.activeStepIndex = step.isActive ? stepIndex : this.activeStepIndex;
          });
        }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/breadcrumb/breadcrumb.component.ts